<div class="content">
  <div class="description subtitle">
    {{ 'AUTOMATIONS.EDITOR.TASKS.ACTIVATE_PRODUCT.DESCRIPTION' | translate }}
  </div>
  <div class="form">
    <ng-container *ngIf="appOptions$ | async as appOptions; else loading">
      <glxy-form-field [required]="true">
        <glxy-label>
          {{ 'AUTOMATIONS.EDITOR.TASKS.ACTIVATE_PRODUCT.PRODUCTS' | translate }}
        </glxy-label>
        <mat-select [formControl]="productControl" multiple [required]="true">
          <mat-select-trigger>
            {{ productControl.value?.length > 0 ? (getProductNameFromString(productControl.value[0]) | async) : '' }}
            <span *ngIf="productControl.value?.length > 1">
              (+{{ productControl.value.length - 1 }}
              {{
                (productControl.value?.length === 2
                  ? 'AUTOMATIONS.EDITOR.FILTERS.OTHER'
                  : 'AUTOMATIONS.EDITOR.FILTERS.OTHERS'
                ) | translate
              }})
            </span>
          </mat-select-trigger>
          <ng-container *ngFor="let app of appOptions">
            <ng-container *ngIf="app.disabled">
              <mat-option
                [value]="app.value"
                disabled="true"
                [glxyTooltip]="'AUTOMATIONS.EDITOR.TASKS.ACTIVATE_PRODUCT.PRICING_NOT_CONFIGURED' | translate"
              >
                {{ app.label }}
              </mat-option>
            </ng-container>
            <ng-container *ngIf="!app.disabled">
              <mat-option [value]="app.value">
                {{ app.label }}
              </mat-option>
            </ng-container>
          </ng-container>
        </mat-select>
      </glxy-form-field>
    </ng-container>
    <div class="product-details-list" *ngIf="appPrices$ | async as appPrices">
      <div class="product-details">
        <div class="column-title">
          {{ 'AUTOMATIONS.EDITOR.TASKS.ACTIVATE_PRODUCT.PRODUCT_NAME' | translate }}
        </div>
        <div class="column-title">
          {{ 'AUTOMATIONS.EDITOR.TASKS.ACTIVATE_PRODUCT.WHOLESALE_COST' | translate }}
        </div>
      </div>
      <div class="product-details" *ngFor="let appPrice of appPrices">
        <div>
          {{ getProductNameFromAppId(appPrice.appId) | async }}
        </div>
        <billing-ui-price-display
          [appPrice]="appPrice.pricesForContexts['wholesale']"
          [align]="'end'"
          [editionId]="getProductEditionFromAppId(appPrice.appId) | async"
          [currencyCode]="partnerCurrency$ | async"
        ></billing-ui-price-display>
      </div>
    </div>
  </div>

  <ng-template #loading>
    <div class="side-drawer-shimmer-container">
      <span class="selector stencil-shimmer"></span>
    </div>
  </ng-template>
</div>
